import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { useTheme, styled } from '@mui/material/styles';
import { Grid, Container, Typography, Tabs, Tab, Stack, ButtonBase, Modal, Box, CircularProgress, Tooltip } from '@mui/material';
// components

import LocationCityIcon from '@mui/icons-material/LocationCity';
import StoreMallDirectoryIcon from '@mui/icons-material/StoreMallDirectory';
import { HomeFilled, UserOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import dayjs from 'dayjs';

// sections
// import { AppCurrentVisits, AppWebsiteVisits } from '../../sections/@dashboard/app';
// import UserPage from '../UserPage';
// import zodiacApiFunctions from '../../API/zodiacApi';

// import LocationPage from '../LocationPage';

// import { useStoreId } from './sections/@dashboard/app/StoreProviders';
import { Refresh } from '@mui/icons-material';
import { DatePicker } from 'antd';

import apiFunctions from '../../API/api';
import WhatsappApiFunctions from '../../API/whatsapp';
import {
  AppWidgetSummary,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppConversionRates,
  AppWidgetSummary2,
  PostSearch,
} from '../../sections/@dashboard/app';
import zodiacApiFunctions from '../../API/zodiacApi';

import { useFilter } from '../../layouts/dashboard/FilterProvider';
// import DownloadReport from '../DownloadReport';
// import Genral from './Genral';
// import DownloadZodiacReport from './DownloadZodiacReport';
import LuckyMeterReport from '../LuckyMeterReport';
import Genral from '../Zodiac/Genral';
import BaseColor from '../../BaseColor';
import DigitalMessageReport from './DigitalMessageReport';
import DigitalMessageTable from './DigitalMessageTable';
import VoucherTable from '../VoucherTable';
// import { WhatsApp } from '@mui/icons-material';
// ----------------------------------------------------------------------
// Styled components should be defined after all regular imports
const StyledTabs = styled(Tabs)(({ theme }) => ({
  overflow: 'hidden',
  '& .MuiTabs-flexContainer': {
    width: '100%',
    justifyContent: 'space-evenly',
    // background: 'linear-gradient(to right, #FFE22D 20%, #FFF5B7 80% )',
    background: 'linear-gradient(180deg, #0064d9 0%, #11428c 100%)',
    borderRadius: '1rem',
    flexWrap: 'wrap', // Set flex-wrap to 'wrap' for larger screens
    overflowX: 'auto',
    scrollbarWidth: 'none',
    '-ms-overflow-style': 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'nowrap', // Set flex-wrap to 'nowrap' for smaller screens
      maxWidth: '100%', // Add this to limit the maximum width
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'nowrap', // Set flex-wrap to 'nowrap' for smaller screens
      maxWidth: '80%', // Add this to limit the maximum width
    },
  },
  '& .Mui-selected': {
    borderBottom: `2px solid ${BaseColor}`, // Change the color and width of the active indicator here
    minWidth: '50px', // Set the width of the active indicator to match tab minWidth
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  flex: '0 0 auto',
  // minWidth: '50px', // Default width for larger screens and active indicator
  color: '#ffe22e',
  fontSize: '1rem',
  '&.Mui-selected': {
    color: 'black',
  },

  // Responsive tab sizing
  [theme.breakpoints.down('sm')]: {
    // minWidth: '150px', // Adjust tab width for small screens (e.g., tablets)
    fontSize: '0.9rem', // Adjust font size for small screens
    padding: '0',
    margin: '0',
    width: '33%',
  },
  [theme.breakpoints.down('xs')]: {
    minWidth: '20px', // Further reduce tab width for phones
    fontSize: '0.8rem', // Further reduce font size for phones
    width: 'max-content',
    padding: '0',
    margin: '0',
  },
}));
export default function DigitalMessage() {
  const childRef = useRef(null);

  const theme = useTheme();
  const [value, setValue] = useState(0);
  const [count, setCount] = useState([]);
  const [date, setDate] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalVisits, setTotalVisits] = useState(0);
  const [couplesCount, setCouplesCount] = useState(0);

  const [visitDates, setVisitDate] = useState([]);

  const [visitCounts, setVisitCount] = useState([]);
  const [userData, setUserData] = useState();

  const [leaderboard, setLeaderboard] = useState([]);
  const [leaderBoardStoreId, setLeaderBoardStoreId] = useState([]);
  const [leaderBoardCount, setLeaderBoardCount] = useState([]);
  const currentYear = new Date().getFullYear();
  const [totalShares, setTotalShares] = useState(0);
  const [totalViews, setTotalViews] = useState(0);
  const [shareDateAnalytics, setShareDateAnalytics] = useState([]);
  const [shareCountAnalytics, setShareCountAnalytics] = useState([]);
  const [viewDateAnalytics, setViewDateAnalytics] = useState([]);
  const [viewCountAnalytics, setViewCountAnalytics] = useState([]);
  const [readCount, setReadCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [sentCount, setSentCount] = useState();

  const [occasionWiseCount, setOccasionWiseCount] = useState([]);

  const [rating1, setRating1] = useState([]);
  const [count1, setCount1] = useState([]);

  const [rating2, setRating2] = useState([]);
  const [count2, setCount2] = useState([]);
  const [storeId, setStoreId] = useState([]);
  const [selectedStore, setSelectedStore] = useState(0);
  const [voucherUserDetail, setVoucherUserDetail] = useState([]);
  const [voucherWiseUsage, setVoucherWiseUsage] = useState([]);
  const [voucherWiseLeaderBoard, setVoucherWiseLeaderBoard] = useState([]);
  const [Receiver, setRecevier] = useState([]);
  const [Gifter, setGifter] = useState([]);
  const [TotalSharess, setTotalSharess] = useState([]);
  const [deliveredCount, setDeliveredCount] = useState(0);
  const [failureCount, setFailureCount] = useState(0);
  const [GifterAverageRating, setGifterAverageRating] = useState([]);
  const [ReceiverAverageRating, setReceiverAverageRating] = useState([]);
  const [Redirect, setRedirect] = useState([]);
  const [loaderOpen, setLoaderOpen] = useState(false);
  // const [selectedOption, setSelectedOption] = useState({ Option: 'ALL', id: 0 });
  
  // Centralized filter state
  const [templateOptions, setTemplateOptions] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [statusOptions, setStatusOptions] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [searchNumber, setSearchNumber] = useState('');
  
  // Table data state
  const [tableData, setTableData] = useState([]);
  const [tableMessageData, setTableMessageData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableResetKey, setTableResetKey] = useState(0);

  // ---------------date filter start---------------------
  const [alignment, setAlignment] = useState('');
  const { setFilter, filter } = useFilter();
  const [userToggle, setUserToggle] = useState(true);
  const [filterDate, setFilterDate] = useState();
  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };
  const { RangePicker } = DatePicker;
  const currentDate = dayjs(); // Get the current date

  const firstDayOfMonth = currentDate.startOf('month');

  const dateFormat = 'DD-MM-YYYY';
  const weekFormat = 'MM/DD';
  const monthFormat = 'YYYY/MM';

  const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY'];
  const customFormat = (value) => `custom format: ${value.format(dateFormat)}`;
  const customWeekStartEndFormat = (value) =>
    `${dayjs(value).startOf('week').format(weekFormat)} ~ ${dayjs(value).endOf('week').format(weekFormat)}`;

  const handleDateRangeChange = (dates, dateStrings) => {
    console.log(dates, dateStrings);
    const dateToModify = new Date(dateStrings[1]);
    // Add 1 day to the date
    dateToModify.setDate(dateToModify.getDate() + 1);

    // Format the modified date back to the original format ('YYYY/MM/DD')
    const modifiedDate = `${dateToModify.getFullYear()}/${(dateToModify.getMonth() + 1)
      .toString()
      .padStart(2, '0')}/${dateToModify.getDate().toString().padStart(2, '0')}`;

    // Update the date in the array
    // dateStrings[1] = modifiedDate;

    const convertedDates = dateStrings.map((date) => {
      console.log('date :', date);
      return date.replace(/\//g, '-');
    });
    const range = {
      fromDate: convertedDates[0],
      toDate: convertedDates[1],
    };

    setFilterDate(range);
    
    // Use centralized filter update function
    updateFilterAndCallAPIs({ date: range });
    
    console.log('📅 Date range updated:', range);
    console.log('📅 Converted dates:', convertedDates);
  };

  // Template change handler
  const handleTemplateChange = (value) => {
    console.log('🔄 DigitalMessage: Template changed to:', value);
    setSelectedTemplate(value);
    updateFilterAndCallAPIs({ template: value });
  };

  // Status change handler
  const handleStatusChange = (value) => {
    console.log('🔄 DigitalMessage: Status changed to:', value);
    setSelectedStatus(value);
    updateFilterAndCallAPIs({ status: value });
  };

  // Search number change handler
  const handleSearchNumberChange = (value) => {
    console.log('🔄 DigitalMessage: Search number changed to:', value);
    setSearchNumber(value);
    updateFilterAndCallAPIs({ number: value });
  };

  // Centralized filter update function that calls APIs in both parent and child
  const updateFilterAndCallAPIs = async (filterUpdate, page = 1, pageSize = 5) => {
    const newFilter = {
      type: alignment,
      date: filterDate,
      template: selectedTemplate,
      status: selectedStatus,
      number: searchNumber,
      ...filterUpdate, // Override with the specific update
    };

    console.log('🚀 Updating filter and calling APIs:', newFilter, 'page:', page, 'pageSize:', pageSize);
    
    // Clear previous data and show loading
    setTableData([]);
    setTableMessageData([]);
    setTableLoading(true);
    setLoaderOpen(true);
    
    setFilter(newFilter);

    // Call all APIs with pagination
    await callAllAPIs(newFilter, page, pageSize);
  };

  // Function to call all APIs including table data
  const callAllAPIs = async (currentFilter, page = 1, pageSize = 5) => {
    try {
      
      console.log('🚀 Calling all APIs with filter:', currentFilter, 'page:', page, 'pageSize:', pageSize);
      
      // Selected API: ListMessage (uses number, template, status, from/to, page/size)
      const listMessageResponse = await WhatsappApiFunctions.getListMessage(currentFilter, page, pageSize);
      if (listMessageResponse && listMessageResponse.Contact) {
        setTableData(listMessageResponse.Contact);
        if (listMessageResponse.Count !== undefined) {
          setTotalCount(listMessageResponse.Count);
        }
      } else {
        setTableData([]);
        setTotalCount(0);
      }
      
      
      console.log('✅ All APIs called successfully');
    } catch (error) {
      console.error('❌ Error calling APIs:', error);
    } finally {
      // Hide loading states
      setTableLoading(false);
      setLoaderOpen(false);
    }
  };

  // Function to handle page changes
  const handlePageChange = async (newPage, pageSize) => {
    const currentFilter = {
      type: alignment,
      date: filterDate,
      template: selectedTemplate,
      status: selectedStatus,
      number: searchNumber,
    };
    
    setTableLoading(true);
    await callAllAPIs(currentFilter, newPage + 1, pageSize);
  };

  // Ensure APIs run on every filter date change (fallback if updates happen outside our handlers)
  useEffect(() => {
    const from = filter?.date?.fromDate;
    const to = filter?.date?.toDate;
    if (!from || !to) return;

    console.log('🎯 Filter dates changed -> triggering callAllAPIs', { from, to });
    // Clear previous data and show loading before API
    setTableData([]);
    setTableLoading(true);
    setLoaderOpen(true);

    const currentFilter = {
      type: alignment,
      date: { fromDate: from, toDate: to },
      template: selectedTemplate,
      status: selectedStatus,
      number: searchNumber,
    };

    // Fire with current page 1
    callAllAPIs(currentFilter, 1, 5);
  }, [filter?.date?.fromDate, filter?.date?.toDate]);

  // Also trigger when template, status, or number changes
  useEffect(() => {
    const from = filter?.date?.fromDate;
    const to = filter?.date?.toDate;
    if (!from || !to) return;

    console.log('🎯 Template/Status/Number changed -> triggering callAllAPIs', {
      template: selectedTemplate,
      status: selectedStatus,
      number: searchNumber,
    });
    setTableData([]);
    setTableLoading(true);
    setLoaderOpen(true);

    const currentFilter = {
      type: alignment,
      date: { fromDate: from, toDate: to },
      template: selectedTemplate,
      status: selectedStatus,
      number: searchNumber,
    };

    callAllAPIs(currentFilter, 1, 5);
  }, [selectedTemplate, selectedStatus, searchNumber]);

  const handleOpenChange = (open) => {
    if (!open) {
      const range = {
        fromDate: filterDate.fromDate,
        toDate: filterDate.toDate,
      };
      const newFilter = {
        type: alignment,
        date: range,
        template: filter.template,
        status: filter.status,
      };
      setFilter(newFilter);
    }
  };

  const handleFilter = async () => {
    const newFilter = {
      type: alignment,
      date: filter.date,
      template: filter.template,
      status: filter.status,
    };
    setFilter(newFilter);
  };
  // const location = useLocation();
  // useEffect(() => {
  //   if (location.pathname === '/dashboard/app') {
  //     setUserToggle(true);
  //   } else {
  //     setUserToggle(false);
  //   }
  //   console.log(location.pathname === '/dashboard/zodiac');
  // }, [location]);
  // ---------------date filter end---------------------

  const nav = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token === '' || token === 'undefined' || token === undefined || token === null) {
      // nav('/login');
    }
  }, []);

  async function getAnalyticsCounts() {
    try {
      const response = await WhatsappApiFunctions.getAnalyticsCount(filter);
      console.log('📊 Analytics response:', response);
      
      // Update total count
      setTotalCount(response.Count);
      
      // If response has Contact data with detailed counts, update them
      if (response.Contact && response.Contact.length > 0) {
        const { SentCount, DeliveredCount, ReadCount, FailureCount, TotalCount } = response.Contact[0];
        
        if (SentCount !== undefined) setSentCount(SentCount);
        if (DeliveredCount !== undefined) setDeliveredCount(DeliveredCount);
        if (ReadCount !== undefined) setReadCount(ReadCount);
        if (FailureCount !== undefined) setFailureCount(FailureCount);
        if (TotalCount !== undefined) setTotalCount(TotalCount);
      }
    } catch (error) {
      console.error('Error fetching analytics count:', error);
    }
  }
  useEffect(() => {
    // async function getUsers() {
    //   function formatDate(dateString) {
    //     const options = { month: 'numeric', day: '2-digit', year: 'numeric' };
    //     const date = new Date(dateString);
    //     return date.toLocaleDateString(undefined, options);
    //   }
    //   try {
    //     const data = await apiFunctions.getUserData(filter);
    //     setTotalUsers(data.totalUserCountBetweenDates);
    //     // const countMarital = data.userData.filter((user) => user.Marital === 1).length;
    //     // setCouplesCount(countMarital);
    //     setUserData(data.userData);
    //     // setUsedGV(data.used);
    //     const dates = data.dateWiseUserCounts.map((entry) => entry.date);
    //     const counts = data.dateWiseUserCounts.map((entry) => entry.count);

    //     const formattedDates = dates.map((date) => new Date(date));

    //     // Format each date string in the array
    //     const FinalDate = formattedDates.map(formatDate);
    //     FinalDate.sort((a, b) => {
    //       const dateA = new Date(a);
    //       const dateB = new Date(b);
    //       return dateA - dateB;
    //     });
    //     setCount(counts);
    //     setDate(FinalDate);
    //   } catch (error) {
    //     console.error('Error fetching user counts:', error);
    //     // Handle error if needed
    //   }
    // }

    async function getVisits() {
      function formatDate(dateString) {
        const options = { month: 'numeric', day: '2-digit', year: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, options);
      }
      try {
        const data = await apiFunctions.getVisitCounts(filter);
        setTotalVisits(data.totalCountBetweenDates);
        const dates = data.dateWiseCounts.map((entry) => entry.date);
        const counts = data.dateWiseCounts.map((entry) => entry.count);

        const formattedDates = dates.map((date) => new Date(date));

        // Format each date string in the array
        const FinalDate = formattedDates.map(formatDate);
        FinalDate.sort((a, b) => {
          const dateA = new Date(a);
          const dateB = new Date(b);
          return dateA - dateB;
        });
        setVisitCount(counts);
        setVisitDate(FinalDate);
      } catch (error) {
        console.error('Error fetching user counts:', error);
        // Handle error if needed
      }
    }

    async function getMessageLeaderBoard() {
      try {
        const data = await apiFunctions.getMessageLeaderBoard(filter, selectedStore);
        const date = data.DayWiseReport.map((entry) => formatDate(entry.date));
        const count = data.DayWiseReport.map((entry) => entry.count);
        const transformedData = data?.DayWiseReport?.map((item) => ({
          label: formatDate(item.date),
          value: item.count,
        }));

        // setLeaderboard(transformedData);
        setLeaderBoardStoreId(date);
        setLeaderBoardCount(count);
      } catch (error) {
        console.error('Error fetching user counts:', error);
      }
    }
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return format(date, 'dd-MM-yy');
    };

    async function getMessageLeaderBoard2() {
      try {
        const data = await apiFunctions.getMessageLeaderBoard2(filter);
        const StoreId = data.Global.map((entry) => entry.StoreId);
        const count = data.Global.map((entry) => entry.count);
        const transformedData = data?.Global?.map((item) => ({
          label: item.StoreId,
          value: item.count,
        }));

        setLeaderboard(transformedData);
      } catch (error) {
        console.error('Error fetching user counts:', error);
      }
    }

    async function getMessageAnlytics() {
      try {
        const analyticsData = await apiFunctions.getMessageAnlytics(filter, selectedStore);
        const { TotalShares, TotalViews, shares, views } = analyticsData[0];
        setTotalShares(TotalShares);
        setTotalViews(TotalViews);

        const shareDate = shares.map((entry) => formatDate(entry.date));
        const shareCount = shares.map((entry) => entry.count);
        setShareDateAnalytics(shareDate);
        setShareCountAnalytics(shareCount);

        const viewDate = views.map((entry) => formatDate(entry.date));
        const viewCount = views.map((entry) => entry.count);
        setViewDateAnalytics(viewDate);
        setViewCountAnalytics(viewCount);
      } catch (error) {
        console.error('Error fetching user counts:', error);
      }
    }

    async function getOccasionWiseData() {
      try {
        const response = await apiFunctions.getOccasionWiseData(filter, selectedStore);
        const transformedData = response?.map((item) => ({
          label: item.OccasionName,
          value: item.count,
        }));
        setOccasionWiseCount(transformedData);
      } catch (error) {
        console.error('Error fetching user counts:', error);
      }
    }

    async function getGifterWiseRating() {
      try {
        const response = await apiFunctions.getMessageRating(filter, 1, selectedStore);
        // const [ratings, counts] = getCounts(response.RatingWiseCount);
        setRating1(getCounts(response.RatingWiseCount));
        // setCount1(counts);
        // console.log('Ratings:', ratings);
        // console.log('Counts:', counts);
      } catch (error) {
        console.error('Error fetching user counts:', error);
      }
    }
    async function getReceiverWiseRating() {
      try {
        const response = await apiFunctions.getMessageRating(filter, 2, selectedStore);
        setRating2(getCounts(response.RatingWiseCount));
        // setCount2(counts);
        // console.log('Ratings:', ratings);
        // console.log('Counts:', counts);
      } catch (error) {
        console.error('Error fetching user counts:', error);
      }
    }

    async function getVoucherDetails() {
      try {
        const response = await apiFunctions.getVoucherDetails(filter);
        const { UserDetail, VoucherWiseUsage, LeaderBoardCountReport } = response;
        setVoucherUserDetail(UserDetail);

        setVoucherWiseUsage(VoucherWiseUsage[0]);
        setVoucherWiseLeaderBoard(LeaderBoardCountReport);
        // setRating2(getCounts(response.RatingWiseCount));
        // setCount2(counts);
        // console.log('Ratings:', ratings);
        // console.log('Counts:', counts);
      } catch (error) {
        console.error('Error fetching user counts:', error);
      }
    }

    async function getListStore() {
      try {
        const response = await apiFunctions.getListStores(filter);
        // [{ Option: 'ALL', id: 0 }, { Option: 'ALL', id: 0 }]
        // Transforming the array of objects
        const transformedArray = response.Stores.map((store) => ({
          Option: store.StoreName,
          id: store.StoreId,
        }));
        setStoreId(transformedArray);
      } catch (error) {
        console.error('Error fetching user counts:', error);
      }
    }

    async function getAnalytic() {
      try {
        const responses = await apiFunctions.getAnalytics(filter, selectedStore);
        // Assuming responses is an array with one object
        const receiverRating = responses[0]?.rating[0]?.ReceiverRating;
        const gifterRating = responses[0]?.rating[0]?.GifterRating;
        const totalShares = responses[0]?.share[0]?.ReceiverShare;
        const receiverViews = responses[0]?.views[0]?.ReceiverView;
        const averageGifterRating = responses[0]?.rating[0]?.GifterAverageRating;
        const averageReceiverRating = responses[0]?.rating[0]?.ReceiverAverageRating;
        const redirect = responses[0]?.redirect[0]?.TotalRedirect;

        const receiverRatingValue = receiverRating !== null && receiverRating !== undefined ? receiverRating : 0;
        const gifterRatingValue = gifterRating !== null && gifterRating !== undefined ? gifterRating : 0;
        const totalSharesValue = totalShares !== null && totalShares !== undefined ? totalShares : 0;
        const receiverViewsValue = receiverViews !== null && receiverViews !== undefined ? receiverViews : 0;
        const averageGifterRatingValue =
          averageGifterRating !== null && averageGifterRating !== undefined ? averageGifterRating : 0;
        const averageReceiverRatingValue =
          averageReceiverRating !== null && averageReceiverRating !== undefined ? averageReceiverRating : 0;
        const redirectValue = redirect !== null && redirect !== undefined ? redirect : 0;

        setRecevier(receiverRatingValue);
        setGifter(gifterRatingValue);
        setTotalSharess(totalSharesValue);
        setDeliveredCount(receiverViewsValue);
        setGifterAverageRating(averageGifterRatingValue);
        setReceiverAverageRating(averageReceiverRatingValue);
        setRedirect(redirectValue);
      } catch (error) {
        console.error('Error fetching analytics:', error);
      }
    }

    async function getRedirectAnalytic() {
      try {
        const responses = await apiFunctions.getRedirectAnalytics(filter);
        // Assuming responses is an array with one object
      } catch (error) {
        console.error('Error fetching analytics:', error);
      }
    }

    // getAnalytic();
    // getListStore();
    // getMessageAnlytics();
    // getMessageCount();
    // getOccasionWiseData();
    // getGifterWiseRating();
    // getReceiverWiseRating();
    // getVoucherDetails();
    // getUsers();
    // getVisits();
    // getAnalyticsCounts(); // Now handled by callAllAPIs

    // getMessageLeaderBoard2();
  }, [filter, selectedStore]);

  // Fetch template and status options
  useEffect(() => {
    async function getTempleList() {
      try {
        const response = await WhatsappApiFunctions.getTempleList();
        const { Templates } = response;
        setTemplateOptions(Templates);
        console.log('template list : ', response);
      } catch (error) {
        console.error('Error fetching template list:', error);
      }
    }

    async function getStatusList() {
      try {
        const response = await WhatsappApiFunctions.getStatusList();
        const { StatusList } = response;
        setStatusOptions(StatusList);
        console.log('status list : ', response);
      } catch (error) {
        console.error('Error fetching status list:', error);
      }
    }

    getTempleList();
    getStatusList();
  }, []);

  // Initial API call on component mount
  useEffect(() => {
    if (filterDate && (selectedTemplate !== null || selectedStatus !== null || searchNumber !== '')) {
      const initialFilter = {
        type: alignment,
        date: filterDate,
        template: selectedTemplate,
        status: selectedStatus,
        number: searchNumber,
      };
      callAllAPIs(initialFilter);
    }
  }, [filterDate, selectedTemplate, selectedStatus, searchNumber]);

  useEffect(() => {
    console.log('new filtered Date : ', filter);
    console.log('Current filter Date : ', filterDate);
    if (filter?.date?.fromDate !== filterDate?.fromDate) {
      setFilterDate(filter.date);
    } else if (filter?.date?.toDate !== filterDate?.toDate) {
      setFilterDate(filter.date);
    }
  }, [filter]);

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  function getCounts(dataArray) {
    // Initialize an object to store counts for each rating
    const ratingCounts = {};

    // Initialize counts for each rating to 0
    for (let i = 1; i <= 5; i += 1) {
      ratingCounts[i] = 0;
    }

    // Loop through the dataArray and update counts for each rating
    dataArray.forEach((obj) => {
      const rating = obj.Rating;
      if (rating >= 1 && rating <= 5) {
        ratingCounts[rating] += obj.count;
      }
    });

    // Convert the object into an array of objects
    const result = Object.keys(ratingCounts).map((rating) => ({
      label: parseInt(rating, 10),
      value: ratingCounts[rating],
    }));

    // Return the array
    return result;
  }

  const handleUpdateStoreId = (newStoreId) => {
    setSelectedStore(newStoreId);
    // You can perform additional actions here if needed
  };

  // const handleRefresh = () => {
  //   console.log(childRef);
  //   if (childRef.current) {
  //     childRef.current.getTabelDataWhatsapp2();
  //     childRef.current.getTabelDataWhatsapp();
  //   }
  // };

  // const handleUpdateChild = () => {
  //   if (childRef.current) {
  //     alert('calling child component');
  //     childRef.current.getTabelDataWhatsapp2();
  //   }
  // };

  const handleUpdateChild = () => {
    console.log('🔄 DigitalMessage: Manual refresh triggered');
    
    // Reset pagination to first page and refresh all data
    setTableResetKey(prev => prev + 1); // Increment reset key to trigger table reset
    updateFilterAndCallAPIs({}, 1, 5);
  };

  const handleOpenloader = () => {
    if (filter.number.length === 0) {
      setLoaderOpen(true);
    }
  };
  const handleCloseloader = () => {
    setLoaderOpen(false);
  };

  return (
    <>
      <Helmet>
        <title> Xploro </title>
      </Helmet>

      <Container maxWidth="xl" sx={{ position: 'relative' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h4" sx={{ mb: 5, color: 'black' }}>
            Hi, Welcome back
          </Typography>

          <Stack direction="row" gap={3} alignItems="center">
            {/* Modern Date Range Picker */}
            <RangePicker
              defaultValue={[firstDayOfMonth, currentDate]}
              format={dateFormat}
              id="datepicker"
              allowClear={false}
              style={{
                height: '42px',
                width: '280px',
                borderRadius: '8px',
                border: '1px solid #d9d9d9',
                fontSize: '14px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
              value={[
                filterDate?.fromDate ? dayjs(filterDate.fromDate, dateFormat) : dayjs(firstDayOfMonth, dateFormat),
                filterDate?.toDate ? dayjs(filterDate.toDate, dateFormat) : dayjs(currentDate, dateFormat),
              ]}
              onChange={handleDateRangeChange}
            />
            
            {/* Template Select */}
            {templateOptions?.length > 0 && (
              <select
                value={selectedTemplate || ''}
                onChange={(e) => handleTemplateChange(e.target.value)}
                style={{
                  height: '42px',
                  minWidth: '200px',
                  padding: '8px 12px',
                  borderRadius: '8px',
                  border: '1px solid #d9d9d9',
                  fontSize: '14px',
                  backgroundColor: 'white',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  cursor: 'pointer',
                }}
              >
                <option value="">All Templates</option>
                {templateOptions.map((template) => (
                  <option key={template.TemplateName} value={template.MessageTemplateKey}>
                    {template.TemplateName}
                  </option>
                ))}
              </select>
            )}

            {/* Status Select */}
            {statusOptions?.length > 0 && (
              <select
                value={selectedStatus || ''}
                onChange={(e) => handleStatusChange(e.target.value)}
                style={{
                  height: '42px',
                  minWidth: '150px',
                  padding: '8px 12px',
                  borderRadius: '8px',
                  border: '1px solid #d9d9d9',
                  fontSize: '14px',
                  backgroundColor: 'white',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  cursor: 'pointer',
                }}
              >
                <option value="">All Status</option>
                {statusOptions.map((status) => (
                  <option key={status.MessageStatus} value={status.MessageStatus}>
                    {status.MessageStatus}
                  </option>
                ))}
              </select>
            )}

            
            {/* Modern Refresh Button */}
            <Tooltip title="Refresh" placement="top">
              <ButtonBase
                sx={{
                  borderRadius: '8px',
                  height: '42px',
                  minWidth: '30px',
                  backgroundColor: '#f0f0f0',
                  color: '#333',
                  padding: '0 12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '14px',
                  fontWeight: 500,
                  boxShadow: '0 2px 4px rgba(0,0,0,0.06)',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: '#f8f8f8',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.12)',
                  },
                }}
                onClick={handleUpdateChild}
              >
                <Refresh sx={{ fontSize: '18px' }} />
              </ButtonBase>
            </Tooltip>
            {/* Digital Message Report */}
            <DigitalMessageReport selectedStore={selectedStore} />
          </Stack>
        </div>
        {/* 
        <StyledTabs value={value} onChange={handleChange} aria-label="icon position tabs example" indicatorColor="red">
          <StyledTab
            icon={<HomeFilled style={{ marginLeft: '5px' }} />}
            label="General"
            iconPosition="start"
            sx={{
              color: 'black',
              fontSize: '1rem',
            }}
          />
          <StyledTab
            icon={<LocationCityIcon style={{ marginLeft: '5px' }} />}
            iconPosition="end"
            label="Voucher Details"
            sx={{
              color: 'black',
              fontSize: '1rem',
            }}
          />
        </StyledTabs> */}
        <br />
        {/* <Grid item xs={12} md={6} lg={3}> */}
        {/* <AppWidgetSummary2
              title="Total Users"
              total={totalUsers}
              color="success"
              icon={<img alt="icon" src="/assets/icons/glass/Coitor/QR.png" style={{ height: '50px' }} />}
            />
          </Grid> */}
        <Grid container>
          {value === 0 && (
            <Grid item xs={12} md={4} lg={3}>
              <AppWidgetSummary2
                title="Total Messages "
                total={totalCount}
                color="success"
                icon={<img alt="icon" src="/assets/icons/navbar/Total_Messages.png" style={{ height: '30px' }} />}
              />
            </Grid>
          )}
        </Grid>

        {/* {value === 0 && (
            <Grid item xs={12} md={6} lg={4}>
              <AppWidgetSummary2
                title="Receiver Shares"
                total={TotalSharess}
                color="success"
                icon={<img alt="icon" src="/assets/Share.png" style={{ height: '50px' }} />}
              />
            </Grid>
          )} */}

        <Grid item xs={12} md={12} lg={12} xl={12} mt={2}>
          {/* {selectedStore && ( */}
          <DigitalMessageTable
            ref={childRef}
            phoneNumber={searchNumber}
            selectedStore={selectedStore}
            openLoader={handleOpenloader}
            closeLoader={handleCloseloader}
            selectedTemplate={selectedTemplate}
            selectedStatus={selectedStatus}
            filterDate={filterDate}
            tableData={tableData}
            totalCount={totalCount}
            tableLoading={tableLoading}
            onPageChange={handlePageChange}
            onSearchChange={handleSearchNumberChange}
            resetKey={tableResetKey}
          />
          {/* )} */}
        </Grid>
      </Container>

      <Modal
        open={loaderOpen}
        onClose={() => setLoaderOpen(false)}
        // sx={{ position: 'absolute', top: '20%', left: '20%' }}
      >
        {/* {loaderOpen && ( */}
        <Box
          sx={{
            // position: 'absolute',
            // top: '50%',
            // left: '50%',
            // transform: 'translate(-50%, -50%)',

            background: 'rgba(0,0,0,0.1)',
            // boxShadow: 24,
            p: 4,
            width: '100%',
            height: '100%',
            textAlign: 'center',
            border: 'none',
            zIndex: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </Box>
        {/* )} */}
      </Modal>
    </>
  );
}
